import { useDispatch } from "react-redux";
import { Link } from "../../molecules/Link";
import { useNavigate } from "react-router-dom";
import { cerrarSesion } from "../../../store/slices/usuario.slice";
import { UsuarioMenu } from "../../molecules/UsuarioMenu";

export const DocenteNavbar = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
// Removed handleLogout as it's not used here

  return (
    <div className={"relative flex flex-row bg-theme-blue p-3"}>
      <nav className={"flex text-white flex-grow"}>
        <Link route={"/inicio"} underline={true} end={false}>
          {"Inicio"}
        </Link>

        <Link route={"/perfilDocente"} underline={true} end={false}>
          {"Mi Perfil"}
        </Link>
        <Link route={"/mis-asistencias"} underline={true} end={false}>
          {"Control de Asistencia"}
        </Link>
      </nav>
      {/* <div className={"flex items-center md:ml-4 mt-4 md:mt-0"}>
        <button
          className="bg-white bg-opacity-50 rounded-md px-3 py-2 text-white my-auto"
          onClick={handleLogout}
        >
          Cerrar sesión
        </button>
      </div> */}
      <UsuarioMenu />
    </div>
  );
};
